import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Group from '../Group/Group';
import TreeSelect from './TreeSelect';
import CustomTreeRenderer from './CustomTreeRenderer';

const treeRenderer = (item, column) =>
  <CustomTreeRenderer item={item} column={column} />;

const DEPTH = 3;

function createItems(start = 0, size = 10, depth = 0, path = '') {
  const items = [];

  for (let j = start; j < start + size; j++) {
    const itemPath = path && path.length > 0 ? `${path}.` : '';
    const subItem = {
      id: `id-${j}`,
      title: `Folder ${itemPath}${j + 1}`,
      description: `Folder with ${size} items`,
      children: depth < DEPTH ? createItems(start, size, depth + 1, `${itemPath}${j + 1}`) : [],
      hasMore: true
    };
    items.push(subItem);
  }
  return items;
}

const createFlatItem = (items, path, searchValue, size, index) => {
  const id = `id-${index}`;
  const title = `Folder ${path}${index + 1}`;
  const description = `Folder with ${size} items`;
  const filtered = searchValue && ![id, title, description].some(attr => attr.includes(searchValue));
  if (!filtered) {
    items.push({ id, title, description, children: [], hasMore: false });
  }
};

const createFlatItems = (searchValue = null) => {
  const size = 10;
  const items = [];
  for (let h = 0; h < size; h++) {
    createFlatItem(items, '', searchValue, size, h);
    for (let i = 0; i < size; i++) {
      createFlatItem(items, `${h + 1}.`, searchValue, size, i);
      for (let j = 0; j < size; j++) {
        createFlatItem(items, `${h + 1}.${i + 1}.`, searchValue, size, j);
      }
    }
  }
  return items;
};

const ITEMS = createItems();

export default class SelectExample extends Component {

  constructor() {
    super();
    this.state = {
      value: ITEMS[2].children[3].children[3],
      value2: ITEMS[2].children[3].children[3],
      items: ITEMS,
      items2: ITEMS,
      category: null,
      categories: [],
      categoriesLoading: false,
      hasMoreCategories: true,
      categoriesPage: 0,
      categorySearch: null
    };
  }

  onChangeProps = e => this.setState(e.target.value);

  onSearchDefault = e => {
    const searchValue = e.target.value;
    this.setState({ value: searchValue, items: createFlatItems(searchValue) });
  };

  onSearchCustom = e => {
    const searchValue = e.target.value;
    this.setState({ value2: searchValue, items2: createFlatItems(searchValue) });
  };

  onSelect = key => e => {
    this.setState({
      [key]: e.target.value,
    });
  };

  onChange = key => e => {
    this.setState({
      [key]: e.target.value,
    });
  };

  onLoadChildren = (e, key) => {
    const items = TreeSelect.recurseUpdateItem(this.state.items, key.split('.'), { isLoading: true });
    this.setState({ items });

    setTimeout(() => {
      const items = TreeSelect.recurseUpdateItem(this.state.items, key.split('.'), { hasMore: false, isLoading: false });
      this.setState({ items });
    }, 2000);
  };

  onExpandCollapse = (e, key) => {
    if (e.target.value && e.target.value.children.length === 0) {
      setTimeout(() => {
        const items = TreeSelect.recurseUpdateItem(this.state.items, key.split('.'), { hasMore: false, children: null });
        this.setState({ items });
      }, 2000);
    }
  };

  render() {
    const { value, value2, items, items2 } = this.state;

    return (
      <Example {...this.props}>
        <Properties
          defaultProps={TreeSelect.defaultProps}
          onChange={this.onChangeProps}
          propTypes={TreeSelect.propTypes}
          propValues={this.state} />
        <Group>
          <h3>Default TreeSelect</h3>
          <TreeSelect
            items={items}
            labelKey="title"
            onExpandCollapse={this.onExpandCollapse}
            onLoadChildren={this.onLoadChildren}
            onSearch={this.onSearchDefault}
            onSelect={this.onSelect('value')}
            value={value}
            valueKey="id" />
          <h3>TreeSelect with custom rendering</h3>
          <TreeSelect
            itemRenderer={treeRenderer}
            items={items2}
            labelKey="title"
            onChange={this.onChange('value2')}
            onExpandCollapse={this.onExpandCollapse}
            onLoadChildren={this.onLoadChildren}
            onSearch={this.onSearchCustom}
            onSelect={this.onSelect('value2')}
            value={value2}
            valueKey="id" />
          <SourceCode querySelector=".core-tree-select" />
        </Group>
      </Example>
    );
  }

}
